import { PERMISSIONS_ENUM } from '../enum/permission.enum';
import { NavigationItem } from '../models/interfaces/navigation';
import { SoctripIcons } from './soctrip-icon.enum';

export const MenuSidebar: NavigationItem[] = [
  {
    path: 'dashboard',
    title: 'dashboard',
    icon: SoctripIcons.BAR_CHART_SQUARE_01,
    permissions: [PERMISSIONS_ENUM.SHOP_ADMIN_DASHBOARD_ACCESS],
  },
  {
    path: 'promotion-program',
    title: 'promotion-program',
    icon: SoctripIcons.TARGET_04,
    permissions: [PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_ACCESS],
  },
  {
    path: 'voucher-shop',
    title: 'voucher-management',
    icon: SoctripIcons.TICKET_01,
    permissions: [PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_ACCESS],
  },
  {
    path: 'voucher-v2',
    title: 'voucher-v2',
    icon: SoctripIcons.TICKET_01,
  },
  {
    path: 'order',
    title: 'order-management',
    icon: SoctripIcons.FILE_SEARCH_02,
    permissions: [
      PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_ACCESS,
      PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_VIEW,
    ],
  },
  {
    path: 'pre-order-product-management',
    title: 'pre-order-product-management',
    icon: SoctripIcons.FILE_05,
  },
  {
    path: 'product-management',
    title: 'product-management',
    icon: SoctripIcons.TAG_02,
    permissions: [PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_ACCESS],
  },
  {
    path: 'shop-management',
    title: 'shop-management',
    icon: SoctripIcons.BUILDING_02,
    permissions: [PERMISSIONS_ENUM.SHOP_MANAGEMENT_ACCESS],
  },
  {
    path: 'refund-management',
    title: 'refund-management',
    icon: SoctripIcons.SHARE_05,
    permissions: [PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_ACCESS],
  },
  {
    path: 'banner-management',
    title: 'banner-management',
    icon: SoctripIcons.IMAGE_INDENT_LEFT,
    permissions: [
      PERMISSIONS_ENUM.BANNER_SHOP_ACCESS,
      PERMISSIONS_ENUM.BANNER_SHOP_VIEW,
    ],
  },
  {
    path: 'faq',
    title: 'faq-assistant',
    icon: SoctripIcons.MESSAGE_QUESTION_SQUARE,
    permissions: [
      PERMISSIONS_ENUM.CHAT_FAQ_ACCESS,
      PERMISSIONS_ENUM.CHAT_FAQ_VIEW,
    ],
  },
  // {
  //   path: 'soctrip-chat',
  //   title: 'soctrip-chat',
  //   icon: SoctripIcons.MESSAGE_CHAT_SQUARE,
  //   permissions: [
  //     PERMISSIONS_ENUM.CHAT_SUPPORT_ACCESS,
  //     PERMISSIONS_ENUM.CHAT_SUPPORT_VIEW_CHAT,
  //   ],
  // },
  // {
  //   path: 'supplier-management',
  //   title: 'supplier-management',
  //   icon: SoctripIcons.FILM_03,
  //   permissions: [PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_ACCESS],
  // },
  // {
  //   path: 'connect-sellers-management',
  //   title: 'connect-sellers-management',
  //   icon: SoctripIcons.DOTS_GRID,
  //   permissions: [PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS],
  // },
  {
    path: 'promo-section',
    title: 'promo-section',
    icon: SoctripIcons.WALLET_05,
    permissions: [PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ACCESS],
  },

  {
    path: '',
    title: 'home-connect',
    icon: SoctripIcons.ROUTE,
    children: [
      {
        path: 'supplier-management',
        title: 'supplier-management',
        permissions: [PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_ACCESS],
      },
      {
        path: 'connect-sellers-management',
        title: 'connect-sellers-management',
        permissions: [PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS],
      },
      // {
      //   path: 'seller-group',
      //   title: 'seller-group',
      // },
    ],
  },
  {
    path: 'global-selling',
    title: 'global-selling',
    icon: SoctripIcons.GLOBE_06,
    children: [
      {
        path: 'registered-shops',
        title: 'registered-shops',
      },
      {
        path: 'registered-products',
        title: 'registered-products',
      },
      {
        path: 'international-products',
        title: 'international-products',
      },
      {
        path: 'route-settings',
        title: 'route-settings',
      },
    ],
  },
  {
    path: 'rss-config',
    title: 'RSS',
    icon: SoctripIcons.SETTINGS_01,
  }
];
